export const amplitudeId = process.env.NEXT_PUBLIC_AMPLITUDE;
export const dashboardUrl = process.env.NEXT_PUBLIC_DASHBOARD_URL;
export const airtableApiKey = process.env.NEXT_PUBLIC_AIRTABLE_API_KEY;
export const recaptchaKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY;
export const supportFormUrl = process.env.NEXT_PUBLIC_SUPPORT_FORM_URL;
